import { configureStore } from '@reduxjs/toolkit'
import authSlice from './action/AuthRedux'
import settingsReducer from './action/settingsReducer'
import videoReducer from './action/videoReducer'
import InstagramDashboard from './action/instagramDashboard'

const store = configureStore({
   reducer: {
      user: authSlice,
      settings: settingsReducer,
      videoRedux: videoReducer,
      instagramDashboard: InstagramDashboard
   }
})

export default store
